import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(timezone)

export const getTimezone = () => {
  return dayjs.tz.guess()
}
